// extracted by mini-css-extract-plugin
module.exports = {"title":"InformationContainer_title__1PU7l"};